const config: AppConfig = window.APP_CONFIG || {
  NODE_ENV: process.env.NODE_ENV ?? "development",
  STAGE: process.env.REACT_APP_NODE_ENV ?? "development",
  BASE_URL_API: process.env.REACT_APP_BASE_URL_API ?? "",
  SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN ?? "",
  BUILD_NUMBER: process.env.REACT_APP_BUILD_NUMBER ?? "0",
  COMMIT_NUMBER: process.env.REACT_APP_COMMIT_NUMBER ?? "dev",
  MOBILE_BASE_URL_API: process.env.MOBILE_BASE_URL_API ?? "dev",
}

export default config
